















































import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import VaIcon from "@/components/atoms/VaIcon.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import WizardService from "@/services/wizardService";
import { DeviceUpdates } from "@/models/deviceConfiguration";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepUpdates",
  mixins: [wizardStepsMixin],
  data() {
    return {
      updates: undefined as DeviceUpdates | undefined,
      updating: false,
    };
  },
  components: { VaIcon, VaButton },
  computed: {},
  watch: {
    deviceConfiguration: function () {
      this.checkUpdates();
    },
  },
  methods: {
    async checkUpdates() {
      try {
        this.loading = true;
        this.updates = await WizardService.checkUpdates(
          this.deviceConfiguration
        );
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    async updateDevice() {
      if (!this.updates) return;
      try {
        this.loading = true;
        this.updating = true;
        await WizardService.updateDevice(
          this.deviceConfiguration,
          this.updates.downloadUrl
        );
        // this.$emit('onRestart');
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
  },
});
